<div [ngClass]="paddingClass" class="Offcanvas__header" >
    <div class="Offcanvas__heading">{{header}}</div>
    <div class="Offcanvas__Iconscontainer">
        <div  [ngClass]="ExtraIconClass "><img [src]="iconSrc" (click)="clear_Filter()" alt=""></div>
        <div class="Offcanvas__cancelIcon" (click)="closeOffcanvas()"  >
            <img src="../../../assets/Images/roles-responsibilities/cancel.svg" alt="cancelIcon">
        </div>
    </div>
</div>